export default {
  countries: [],

  // Dashboard operations variables
  changelog: false,
  isCookies: false,
  isLoading: true,
  isMini: false,
  drawer: false,
  isDark: false,

  isHolesEditting: false,
  isRestrictedEditting: false,

  whitelabel: {},

  language: 'ES',

  width: {
    full: window.innerWidth,
    dialog: window.innerWidth * 0.8333333333 // 10 of 12 columns
  }
}
